import { SeoUrlDetailsType } from "../pages/BussinessHomePage";
import { ClickActionIDType } from "./form_table_data_types";

interface SubjectClassSectionSel {
  class: string;
  section: string;
  subject: string;
  subjectId: string;
}
interface LoginInfo {
  isLoggedIn: boolean;
  bhpPromoLoaded: boolean;
  bhpEditMode: boolean;
  bhpVerify: boolean;
  promptFeedbackNDirectionDone: boolean;
}
const reportCardModalStatus = {
  initial: "Initial",
  generating: "Generating",
  review: "Review",
  finish: "Finish",
};
interface ReportCardStudentInfo {
  name: string;
  id: string;
  roll: number;
  selected?: boolean;
  missingData?: string[];
  reportCardFName?: string;
  isGenerated?: boolean;
}
interface ReportCardStruct {
  status: string;
  students: ReportCardStudentInfo[];
}

interface SubjectTeacherInfo {
  subjectName: string;
  subjectId: string;
  class: string;
  section: string;
}
// Teacher Info
// -- id
// -- name
// -- subject Teacher []
//     -- subject Name
//     -- class Section []
//         -- class
//         -- section
// -- current Session
// -- class Teacher
//      -- class
//      -- section
// -- school name
// -- school ID
interface TeacherInfo {
  id: string;
  name: string;
  schoolId: string;
  phoneNumber: number;
  associateInstitutes?: { id: string; name: string }[];
  subjectTeacher?: SubjectTeacherInfo[];
  currentSession: { id: string; name: string };
  classTeacher?: {
    class: string;
    section: string;
    coScholastics: { subjectName: string; subjectId: string }[];
  };
  schoolName?: string;
  displaySchoolId?: string;
  city: string;
  state: string;
  linkedInUrl: string;
}

interface ProfileData {
  id: string;
  name: string;
  email: string;
  phone: number;
  picture: string;
  dob: string;
  gender: string;
  aboutMe: string;
}

interface ExamType {
  id: string;
  isGrade: boolean;
  name: string;
  maxLimit: number;
  passingLimit: number;
  gradeLabelsArrDes?: string[];
}

interface ExamEntry {
  name: string;
  id: string;
  marks: number;
  type: ExamType;
}

interface SubjectExamEntry {
  name: string;
  id: string;
  isScholastic: boolean;
  examEntries: ExamEntry[];
}

interface BehaviorTraitsStudentMarks {
  name: string;
  id: string;
  marks: number;
  isScholastic: boolean;
}

interface BehaviorTraitsAllStudentMarks {
  name: string;
  id: string;
  roll: string;
  marks: BehaviorTraitsStudentMarks[];
}

interface ExamsBehaviorEntry {
  name: string;
  id: string;
  type: ExamType;
  behaviorTraitStudentMarks: BehaviorTraitsAllStudentMarks[];
}

interface StudentExamEntry {
  name: string;
  roll: number;
  id: string;
  subjectExamEntries: SubjectExamEntry[];
  behaviorTraitEntries: SubjectExamEntry[];
}

interface StudentSpecificSubjectExamEntry {
  name: string;
  roll: number;
  id: string;
  subjectExamEntry: SubjectExamEntry;
}

// Entry for all students and all subjects and all exams (schol + co-schol + behavior)
//   -- session
//   -- class
//   -- section
//   -- student entries []
//        -- student name
//        -- roll
//        -- id
//        -- subject entries [] (schol + co-schol)
//             -- subject name
//             -- is Scholatic
//             -- subject id
//             -- exams []
//                  -- name
//                  -- id
//                  -- marks
//                  -- type
//                       -- type name
//                       -- id
//                       -- is Grade
//                       -- max marks
//                       -- passing marks
//                       -- grade labels []
//        -- subject entries [] (behavior)
//             -- subject name
//             -- is Scholatic
//             -- subject id
//             -- exams []
//                  -- name
//                  -- id
//                  -- marks
//                  -- type
//                       -- type name
//                       -- id
//                       -- is Grade
//                       -- max marks
//                       -- passing marks
//                       -- grade labels []
interface ClassSectionSessionExamEntry {
  session: string;
  class: string;
  section: string;
  studentExamEntries: StudentExamEntry[];
}

interface StudentMarks {
  name: string;
  roll: number;
  id: string;
  marks: number;
}

interface BehaviorExamEntry {
  name: string;
  id: string;
  studentMarks: StudentMarks[];
  type: ExamType;
}

interface BehaviorTraitsMarks {
  name: string;
  id: string;
  isScholastic: boolean;
  examEntries: BehaviorExamEntry[];
}

// Entry for all students at root for all behavior traits
//   -- session
//   -- class
//   -- section
//   -- exams []
//        -- student Marks []
//             -- name
//             -- id
//             -- roll
//             -- Behavior marks []
//                  -- is Schol
//                  -- name
//                  -- id
//                  -- marks
//        -- name
//        -- id
//        -- type
//             -- type name
//             -- id
//             -- is Grade
//             -- max marks
//             -- passing marks
//             -- grade labels []
interface ClassSectionSessionStudentBehaviorTraits {
  session: string;
  class: string;
  section: string;
  exams: ExamsBehaviorEntry[];
}

// Entry for all behavior traits at root for all students
//   -- session
//   -- class
//   -- section
//   -- behavior traits []
//        -- name
//        -- id
//        -- is Scholatic
//        -- exams []
//             -- name
//             -- id
//             -- student marks []
//                  -- name
//                  -- roll
//                  -- id
//                  -- marks
//             -- type
//                  -- type name
//                  -- id
//                  -- is Grade
//                  -- max marks
//                  -- passing marks
//                  -- grade labels []
interface ClassSectionSessionBehaviorTraits {
  session: string;
  class: string;
  section: string;
  behaviorTraits: BehaviorTraitsMarks[];
}

// Entry for all students all exams and 1 subject (schol / co-schol / behavior)
//   -- session
//   -- class
//   -- section
//   -- student entries []
//        -- student name
//        -- roll
//        -- id
//        -- subject entry (schol / co-schol)
//             -- subject name
//             -- subject id
//             -- is Scholatic
//             -- exams []
//                  -- name
//                  -- id
//                  -- marks
//                  -- type
//                       -- type name
//                       -- id
//                       -- is Grade
//                       -- max marks
//                       -- passing marks
//                       -- grade labels []
interface ClassSectionSessionSpecificSubjectExamEntry {
  session: string;
  class: string;
  section: string;
  studentSpecificSubjectExamEntries: StudentSpecificSubjectExamEntry[];
}

interface MarksBundle {
  testName: string;
  type: ExamType;
  marks: number;
  implementationExams?: MarksBundle[];
}

interface subjectExamMarks {
  name: string;
  id: string;
  totalMarks: MarksBundle;
}

interface TermExams {
  name: string;
  id: string;
  scholasticExams: subjectExamMarks[];
  coScholasticExams: subjectExamMarks[];
}
// Student report
// -- session
// -- class
// -- section
// -- name
// -- id
// -- roll
// -- Exam wrappers like mid-term etc []
//    -- name
//    -- id
//    -- scholatic exams []
//       -- name
//       -- id
//       -- marks bundle []
//          -- test name
//          -- weight
//          -- marks ( marks bundle [] | number)
//          -- type
//             -- name
//             -- isGrade
//             -- marks
//             -- grade list []
interface StudentReportObject {
  session: string;
  class: string;
  section: string;
  id: string;
  termExams: TermExams[];
}

interface StudentList {
  session: string;
  class: string;
  section: string;
  students: {
    name: string;
    roll: number;
    id: string;
    class?: string;
    section?: string;
    house?: string;
  }[];
}

interface StudentAttendanceList {
  session: string;
  class: string;
  section: string;
  students: {
    name: string;
    roll: string;
    id: string;
    attendance: boolean;
    img: string;
  }[];
}

const getGrade = (numberIn: number, gradeArray: string[]): string => {
  const index = gradeArray.length - (numberIn + 1);
  return gradeArray[index];
};

const getMarksFromGrade = (grade: string, gradeArray: string[]): number => {
  return gradeArray.length - parseInt(grade) - 1;
};

interface ReportCardCommentCategory {
  category: string;
  comments: { id: number; comment: string }[];
}

interface StudentSubjectAnecdote {
  anecdote: string;
  id: string;
  userDetails: {
    date: string;
    teacher: string;
    teacherID: string;
  }[];
}

interface PerStudentReportCardCommentBundle {
  name: string;
  roll: string;
  id: string;
  img: string;
  reportCardComments: { comment: string; id: string }[];
  anecdotes: StudentSubjectAnecdote[];
}

interface ReportCardReviewStruct {
  studentId: string;
  images: string[];
}

// Student report card comment
// -- session
// -- class
// -- section
// -- term
// -- students []
//    -- name
//    -- roll
//    -- id
//    -- reportCardComment []
//       -- comment
//       -- id
//    -- annecdotes []
//       -- anecdote
//       -- ID
//       -- userDetails []
//          -- date
//          -- teacher
//          -- teacherID
interface StudentReportCardComments {
  session: string;
  class: string;
  section: string;
  term: string;
  students: PerStudentReportCardCommentBundle[];
}

interface AnecdoteStudentBundle {
  anecdote: string;
  id: string;
  date: string;
  anecdoteID: string;
}

interface PerStudentAnecdoteBundle {
  name: string;
  img: string;
  roll: string;
  id: string;
  anecdotes: AnecdoteStudentBundle[];
}

// Student anecdote
// -- session
// -- class
// -- section
// -- term
// -- students []
//    -- name
//    -- roll
//    -- id
//    -- annecdotes []
//       -- anecdote
//       -- ID (ID of the source anecdote. its empty for free/ edited text)
//       -- date
//       -- anecdote ID
interface StudentAnecdotes {
  session: string;
  class: string;
  section: string;
  term: { id: string; name: string };
  students: PerStudentAnecdoteBundle[];
}

interface AnecdoteInputCategory {
  category: string;
  comments: { text: string; id: string; sentenceConstructor: string }[];
}

interface SaveReportCardCommentObject {
  comment: string;
  id: string;
  teacherID: string;
  session: string;
  studentID: string;
  term: string;
}

interface DelReportCardCommentObject {
  id: string;
  teacherID: string;
  session: string;
  studentID: string;
  term: string;
}

interface FunctionalIcons {
  id: string;
  title: string;
  imagePath: string | any;
  toPath: string;
  isPageNavigation: "Yes" | "No";
  isAccessible: boolean;
}

interface CardGroup {
  title: string;
  functionalIcons: FunctionalIcons[];
}

interface DashboardNavbarGroupType {
  id: number;
  title: string;
  icon: any;
  toPath: string;
}

interface AlertWithExecTypes {
  header?: string;
  message: string;
  open: boolean;
  executeFunc: (input: { [key: string]: any }) => void | Promise<void>;
  funcInputs: {};
  disableCancel?: boolean;
  primaryButtonName?: string;
  cancelButtonName?: string;
}

interface AlertWithoutExecTypes {
  message: string;
  open: boolean;
  header?: string;
}

const AccoladeType = {
  reportCard: "Report Card",
  certificate: "Certificates",
  certification: "Certifications",
  honors: "Honors",
};

interface IprofileAcademicScorePerSubject {
  subjectName: string;
  subjectId: string;
  marks: number;
  totalMarks: number;
  id: string;
}

interface IprofileAcademicScorePerClass {
  standard: string;
  documentId: string;
  marks: IprofileAcademicScorePerSubject[];
}

interface SubjectIntelligenceTraits {
  subject: string;
  id: string;
  intelligence: {
    name: string;
    id: string;
    type: string;
  }[];
  traits: {
    name: string;
    id: string;
    type: string;
  }[];
}

interface AddAccoladeType {
  description?: string;
  type: string;
  isMerit: boolean;
  dateYear: string;
  class: string;
  id: string;
  img: FileBundleType;
  reportCardData?: IprofileAcademicScorePerClass;
  categoryId?: number;
  activityId?: number;
  userDefinedActivity?: string;
}

const accoladeWeight = {
  participation: 1,
  merit: 3,
  certification: 2,
};

interface AccoladeDataType {
  imgName: string;
  date: string;
  class: string;
  studentName?: string;
  // Report Card / Certification/ Certificate
  type?: string;
  description?: string;
  isMerit?: boolean;
  id: string;
  doctitle: string;
  category?: { id: number; name: string };
  activity?: { id: number; name: string };
  userDefinedActivity?: string;
  isScholastic: boolean;
}

interface ProfileDataType {
  name: string;
  profileName: string;
  img: string;
  aboutMe: string;
  dateOfBirth: string;
  id: string;
  accolades?: AccoladeDataType[];
}

interface ProfileAccoladeFilterType {
  date: string[];
  type?: string[];
  campus?: string[];
  filterMerit?: boolean;
}

const iProfileViews = {
  dashboard: "Dashboard",
  accolades: "Accolades",
};

// const suhaniAccolades = `[{"studentName":"Suhani  ","standard":null,"docTitle":"Activities accolades ","type":"Co-curricular","what":"Certificates","WHERE":"Off-campus","WHEN":"2022","docDescription":"Participated in cultural carnival as group dance. Great experience! Met talented personalities and get encouragement to do better","fileName":"d4e55dee-6ed9-442e-8a1f-78a9105ba08d.jpg"},{"studentName":"Suhani  ","standard":null,"docTitle":"Acting","type":"Co-curricular","what":"Certificates","WHERE":"On-campus","WHEN":"2021","docDescription":"Making people aware of pollution free or eco friendly diwali for a better future ","fileName":"79aa187b-163e-4266-9457-c5d3076c4d70.jpg"},{"studentName":"Suhani  ","standard":null,"docTitle":"Writing ","type":"Co-curricular","what":"Certificates","WHERE":"On-campus","WHEN":"2021","docDescription":"Self made hindi poetry on blood donation mela to inspire people for participation in saving someone's life","fileName":"66b48a45-f861-484f-ae75-7765cd6d7d94.jpg"},{"studentName":"Suhani  ","standard":null,"docTitle":"Writing","type":"Co-curricular","what":"Certificates","WHERE":"On-campus","WHEN":"2021","docDescription":"Slogan written on blood donation","fileName":"e33d27d4-96b0-4fb2-ad93-525291e82c8c.jpg"},{"studentName":"Suhani  ","standard":null,"docTitle":"Activities accolades ","type":"Sports","what":"Certificates","WHERE":"On-campus","WHEN":"2021","docDescription":"Yoga quiz ","fileName":"a5bdd8de-c219-4cef-973b-e07f9a609b24.jpg"},{"studentName":"Suhani  ","standard":null,"docTitle":"Olympiad","type":"Academic","what":"Merit Certificates","WHERE":"On-campus","WHEN":"2018","docDescription":"Participated in International S.S.G.K. Maestro Olympiad","fileName":"b22549e4-22a3-4e4e-b73a-fd8c6a04aff0.jpg"},{"studentName":"Suhani  ","standard":null,"docTitle":"Academic Performance ","type":"Academic","what":"Merit Certificates","WHERE":"On-campus","WHEN":"2017","docDescription":"Overall academic and co curriculum topper","fileName":"1471b36e-7843-4a6e-bdfb-5173147abdb0.jpg"},{"studentName":"Suhani  ","standard":null,"docTitle":"Activities accolades ","type":"Co-curricular","what":"Certificates","WHERE":"On-campus","WHEN":"2017","docDescription":"Photo collage making ","fileName":"1c9a6800-86e0-474e-adbd-36542a3395ec.jpg"},{"studentName":"Suhani  ","standard":null,"docTitle":"Dance","type":"Co-curricular","what":"Certificates","WHERE":"On-campus","WHEN":"2018","docDescription":"Folk dance on INDEPENDENCE DAY ","fileName":"87fd8ec9-ee2b-46ed-8037-cb586fc5b1a9.jpg"},{"studentName":"Suhani  ","standard":null,"docTitle":"Activities accolades ","type":"Co-curricular","what":"Certificates","WHERE":"On-campus","WHEN":"2017","docDescription":"Poster making on know thy space","fileName":"ae0d065d-122c-4c43-bae5-e1315c735810.jpg"},{"studentName":"Suhani  ","standard":null,"docTitle":"Activities accolades ","type":"Co-curricular","what":"Certificates","WHERE":"On-campus","WHEN":"2019","docDescription":"Spell bee contest","fileName":"60ac0d7c-dc8e-4bf4-95a2-ec15ca784af5.jpg"},{"studentName":"Suhani  ","standard":null,"docTitle":"Academic Performance ","type":"Academic","what":"Merit Certificates","WHERE":"On-campus","WHEN":"2018","docDescription":"Highest score in ENGLISH, PUNJABI AND SCIENCE IN ANNUAL EXAMINATION ","fileName":"ebef06e4-f505-43b6-a531-4590bc7f0802.jpg"},{"studentName":"Suhani  ","standard":null,"docTitle":"Academic Performance ","type":"Academic","what":"Merit Certificates","WHERE":"On-campus","WHEN":"2017","docDescription":"Highest marks in SOCIAL SCIENCE ","fileName":"12a4db70-a9ab-4b91-af83-bc97341d3fe5.jpg"},{"studentName":"Suhani  ","standard":null,"docTitle":"Acting ","type":"Co-curricular","what":"Certificates","WHERE":"On-campus","WHEN":"2018","docDescription":"As INDIRA GANDHI on REPUBLIC DAY","fileName":"80d929a3-eeee-4593-b003-a384b6698b4c.jpg"},{"studentName":"Suhani  ","standard":null,"docTitle":"Sports","type":"Sports","what":"Certificates","WHERE":"Off-campus","WHEN":"2019","docDescription":"March past competition at sports mela","fileName":"4132e287-eb9f-42fb-879d-adefd2579282.jpg"},{"studentName":"Suhani  ","standard":null,"docTitle":"EMUN 2019","type":"ENVOY MODEL UNITED NATIOND 2029","what":"Certificate","WHERE":"Off-campus","WHEN":"2019","docDescription":"Representative of MEXICO country in WORLD HEALTH ASSEMBLY OF EMUN. Had a great experience with great minds of youth.","fileName":"e87fdeb2-80d9-4502-a23d-b3b79a359f22.jpg"},{"studentName":"Suhani  ","standard":null,"docTitle":"Olympiad","type":"Academic","what":"Merit Certificates","WHERE":"On-campus","WHEN":"2018","docDescription":"INTERNATIONAL OLYMPIAD OF SCIENCE ","fileName":"2072efe3-e780-4e8a-853e-5418c582ec32.jpg"},{"studentName":"Suhani  ","standard":null,"docTitle":"Academic Performance ","type":"Academic","what":"Merit Certificates","WHERE":"On-campus","WHEN":"2020","docDescription":"Stood second in class 9th","fileName":"ec1535bc-0cb6-4989-8258-aba7fb7a7e85.jpg"},{"studentName":"Suhani  ","standard":null,"docTitle":"Academic Performance ","type":"Academic","what":"Merit Certificates","WHERE":"On-campus","WHEN":"2020","docDescription":"Highest marks in hindi","fileName":"7db9fcb6-5549-4e90-949c-87921f71772e.jpg"},{"studentName":"Suhani  ","standard":null,"docTitle":"Olympiad ","type":"Academic","what":"Report Card","WHERE":"Off-campus","WHEN":"2018","docDescription":"","fileName":"4f63fbb0-34b4-4d4d-953e-330abcc19f86.jpg"},{"studentName":"Suhani  ","standard":null,"docTitle":"Writing","type":"Co-curricular","what":"Certificates","WHERE":"On-campus","WHEN":"2018","docDescription":"Caption writing contest ","fileName":"65539234-8155-403b-afe7-64bb2c9d605b.jpg"},{"studentName":"Suhani  ","standard":null,"docTitle":"Academic Performance ","type":"Academic","what":"Merit Certificates","WHERE":"On-campus","WHEN":"2019","docDescription":"Highest marks in punjabi","fileName":"f09c131f-d555-4e5d-8934-107e2392177d.jpg"},{"studentName":"Suhani  ","standard":null,"docTitle":"Academic Performance ","type":"Academic","what":"Merit Certificates","WHERE":"On-campus","WHEN":"2019","docDescription":"Highest marks in hindi and GK","fileName":"e9efefcf-b9a5-4a92-93ab-c3c0e9bd7c7a.jpg"},{"studentName":"Suhani  ","standard":null,"docTitle":"Academic Performance ","type":"Academic","what":"Merit Certificates","WHERE":"On-campus","WHEN":"2019","docDescription":"Standing first in class in annual examination ","fileName":"0d019b0b-23e4-44f3-ae03-8d44d8b6cd55.jpg"},{"studentName":"Suhani  ","standard":null,"docTitle":"Activities accolades ","type":"Co-curricular","what":"Certificates","WHERE":"On-campus","WHEN":"2018","docDescription":"Gift wrapping activity ","fileName":"8b9053d7-7307-4980-9ed1-646505c91d5e.jpg"},{"studentName":"Suhani  ","standard":null,"docTitle":"Activities accolades ","type":"Co-curricular","what":"Certificates","WHERE":"On-campus","WHEN":"2018","docDescription":"Making eco friendly product","fileName":"1451f7cd-ba8f-46cb-b0e8-b647e827aba5.jpg"},{"studentName":"Suhani  ","standard":null,"docTitle":"Academic Performance ","type":"Co-curricular","what":"Certificates","WHERE":"On-campus","WHEN":"2018","docDescription":"Second in I.H. Computer quiz","fileName":"f78556c8-bc62-49e8-b914-b7dcbbbfe360.jpg"},{"studentName":"Suhani  ","standard":null,"docTitle":"Activities accolades ","type":"Co-curricular","what":"Certificates","WHERE":"On-campus","WHEN":"2018","docDescription":"Third in inter house science quiz","fileName":"4a9662a2-eb79-45e2-a84f-e80559f503c1.jpg"},{"studentName":"Suhani  ","standard":null,"docTitle":"Karate","type":"Sports","what":"Medals & Badges","WHERE":"Off-campus","WHEN":"2016","docDescription":"Karate district level competition stood 1 and qualified for state level","fileName":"280dbaa5-cba7-4586-9d97-d837faaaa56d.jpg"},{"studentName":"Suhani  ","standard":null,"docTitle":"Karate","type":"Sports","what":"Certificates","WHERE":"Off-campus","WHEN":"2016","docDescription":"Karate district level","fileName":"ae6d0698-1bbe-40c0-b642-783845517dcc.jpg"},{"studentName":"Suhani  ","standard":null,"docTitle":"NCC","type":"NCC","what":"Certificate","WHERE":"Off-campus","WHEN":"2020","docDescription":"NCC CERTIFICATE-A","fileName":"29bfdb34-3128-44cb-92bb-6ce20ded8bdb.jpg"},{"studentName":"Suhani  ","standard":null,"docTitle":"NCC","type":"NCC","what":"Certificate","WHERE":"Off-campus","WHEN":"2019","docDescription":"NCC ANNUAL TRAINING CAMP CERTIFICATE ","fileName":"c653203e-88bd-47d8-a437-aff1891f27d7.jpg"},{"studentName":"Suhani  ","standard":null,"docTitle":"Activities accolades ","type":"Co-curricular","what":"Certificates","WHERE":"On-campus","WHEN":"2021","docDescription":"Second in poster making on National science day","fileName":"318c62c0-57f7-4b43-a531-246e899f4bde.jpg"},{"studentName":"Suhani  ","standard":null,"docTitle":"Sports","type":"Sports","what":"Medals & Badges","WHERE":"On-campus","WHEN":"2018","docDescription":"Second in open races on athletic meet","fileName":"5739f6af-0296-47a7-903c-ab19db142de5.jpg"},{"studentName":"Suhani  ","standard":null,"docTitle":"Dance","type":"Dance competition ","what":"Certificate","WHERE":"Off-campus","WHEN":"2016","docDescription":"Stood first overall in district in dance competition on Krishna janmashtami","fileName":"d5170b5b-dca2-409c-8884-f23a8e247e28.jpg"},{"studentName":"Suhani  ","standard":null,"docTitle":"Sports","type":"Sports","what":"Medals & Badges","WHERE":"On-campus","WHEN":"2013","docDescription":"First in kabaddi competition ","fileName":"93d84653-fd2b-45fa-9f47-26d59dbc3faa.jpg"},{"studentName":"Suhani  ","standard":null,"docTitle":"Dance ","type":"Dance competition ","what":"Certificate","WHERE":"Off-campus","WHEN":"2016","docDescription":"","fileName":"337f64ab-0ebb-433c-a87d-fc0b7e99af6e.jpg"},{"studentName":"Suhani  ","standard":null,"docTitle":"Academic Performance ","type":"Academic","what":"Report Card","WHERE":"On-campus","WHEN":"2017","docDescription":"","fileName":"dda033f2-a6c1-4425-b5d3-2a97c6a2379c.jpg"},{"studentName":"Suhani  ","standard":null,"docTitle":"Academic Performance ","type":"Academic","what":"Report Card","WHERE":"On-campus","WHEN":"2018","docDescription":"","fileName":"e834a7e1-9ec7-458c-aa79-50d104f0f980.jpg"},{"studentName":"Suhani  ","standard":null,"docTitle":"Academic Performance ","type":"Academic","what":"Report Card","WHERE":"On-campus","WHEN":"2019","docDescription":"","fileName":"94543144-82ec-4ce6-8006-1e97f324c990.jpg"},{"studentName":"Suhani  ","standard":null,"docTitle":"Academic Performance ","type":"Academic","what":"Report Card","WHERE":"On-campus","WHEN":"2021","docDescription":"","fileName":"962a089a-89e1-4518-b3e1-41a102aa0267.jpg"},{"studentName":"Suhani  ","standard":null,"docTitle":"Activities accolades ","type":"Co-curricular","what":"Certificates","WHERE":"Off-campus","WHEN":"2022","docDescription":"","fileName":"2863a55b-489a-4eff-adee-dc51ef9ac90d.jpg"},{"studentName":"Suhani  ","standard":null,"docTitle":"Activities accolades ","type":"Co-curricular","what":"Certificates","WHERE":"On-campus","WHEN":"2021","docDescription":"","fileName":"40ad985b-499a-4551-94db-6298db993ed4.jpeg"},{"studentName":"Suhani  ","standard":null,"docTitle":"Activities accolades ","type":"Co-curricular","what":"Certificates","WHERE":"Off-campus","WHEN":"2021","docDescription":"","fileName":"5a8e6ec9-c9ed-40db-a03a-78a08f052f47.jpg"},{"studentName":"Suhani  ","standard":null,"docTitle":"Certificate ","type":"Sports","what":"Certificates","WHERE":"On-campus","WHEN":"2022","docDescription":"First position in inter house badminton tournament ","fileName":"ed96a614-5e8c-4b16-b53b-f70339dadfb0.jpg"},{"studentName":"Suhani  ","standard":null,"docTitle":"Certificate ","type":"Co-curricular","what":"Certificates","WHERE":"On-campus","WHEN":"2022","docDescription":"Stood first in english poetry writing ","fileName":"e7c9d596-7c84-486e-be90-5ca0e596d5b8.jpg"}]`;
// const SKILL_PERCENTAGE_LIMIT = 0.3;
const ACADEMIC_MARKS_FILTER_LIM = 75;

interface FileBundleType {
  name: string;
  id: string;
  type: string;
  url?: string;
  blob?: Blob;
  rotation?: number;
}

type OrderStatusType =
  | "CREATED"
  | "PARTIALLY_ACCEPTED"
  | "ACCEPTED"
  | "PAID"
  | "COMPLETE"
  | "CANCELLED"
  | "DECLINED"
  | "PROCESSING"
  | "READY"
  | "PICKED_UP";

interface CartItemTypes {
  id: string;
  count: number;
  variantName: string;
  price: number;
  notes: string;
  itemName?: string;
  imgPath?: string;
}

interface HomeWorkDataType {
  subject: { id: string; name: string };
  type: "homework" | "parentcomm";
  class: string;
  section: string;
  date: string;
  dueDate: string;
  data: string;
  files: FileBundleType[];
  id: string;
  creatorName?: string;
}

interface PtmStudentPerLogData {
  log: string;
  date: string;
  session: string;
  teacher: string;
  teacherID: string;
  id: string;
}

interface PtmStudentData {
  name: string;
  id: string;
  logbook: PtmStudentPerLogData[];
}

interface IntelligenceDataType {
  name: string;
  description: string;
  id: string;
}

// const activityType: string[] = [
// "Academic",
// "Literary",
// "Performing Art",
// "Art & Craft",
// "Sports",
// "Organizational",
// "Community",
// ];

interface QuantifyTraitType {
  trait: string;
  count: number;
  ids: string[];
  merit: number;
  // normalization: number;
  percentage: number;
  select: boolean;
}

interface IprofileExpandingImageModalData {
  open: boolean;
  header?: string;
  index: number;
  type: string;
  // urlArray: string[];
  accoladeArray: AccoladeDataType[];
}

interface PositionType {
  coordinate: {
    accuracy: number;
    latitude: number;
    longitude: number;
  };
  timestamp: number;
}

interface MapsGooglePromptType {
  obj?: PositionType;
  url?: string;
  shopName?: string;
  shopId?: string;
  marketName?: string;
  marketId?: string;
  notes?: string;
}

interface AdvanceCustomizationType {
  heroImage?: string[];
  accentColor?: string;
  accentColorContrast?: string;
  hideCategoryNumbers?: boolean;
}

type SubscriptionType =
  | "NONE"
  | "VCARD"
  | "TIER-I"
  | "TIER-II"
  | "CATALOGUE"
  | "PHYSICAL-MENU"
  | "RESIDENT-DIRECTORY";

interface AdvertisingDetailsType {
  id: string;
  campaignId?: number;
  marketPromo?: boolean;
  title: string;
  subTitle: string;
  startDate: string;
  endDate: string;
  saleImg: {
    imgName: string;
    imgData: string;
  }[];
  bgImg: {
    imgName: string;
    imgData: string;
  };
  isMarket?: boolean;
  shopId?: string;
  shopDomain?: string;
  shopAddress?: string;
  shopName?: string;
  shopLocation?: PositionType;
  shopLocationUrl?: string;
  shopPhone?: string;
  shopCategory?: string;
  category?: string;
  callToAction?: string;
  subscriptionType?: "NONE" | "VCARD" | "TIER-I" | "TIER-II";
  approved?: boolean;
  seoUrlDetails?: SeoUrlDetailsType;
  promoType?: "PROMO" | "TRENDS";
  orderMode?: "order" | "query" | "booking";
  exportToMarket?: "YES" | "NO";
  couponMode?: boolean;
}

interface BussinessCatalogueProducts {
  id: string;
  rating?: string | number;
  description: string;
  productList: string;
  name: string;
  imagePath: string[];
  stockImage?: string;
  domain?: string;
  marketName?: string;
  marketDomain?: string;
  advertising?: AdvertisingDetailsType[];
  isSpecial?: boolean;
  isNotListed?: boolean;
  variant: {
    option: string;
    price: number;
    unit: string;
    listPrice?: number;
  }[];
  phoneNumbers?: string;
  shortDescription?: string;
  hasSpecials?: boolean;
  subscriptionType?: SubscriptionType;
  subTitle?: string;
  floor?: string;
  seoUrlDetails?: SeoUrlDetailsType;
  location?: PositionType;
  locationUrl?: string;
}

interface BhpCampaignType {
  id: number;
  campaignName: string;
  bgColor?: string;
  textColor?: string;
  image?: string;
}

type PrivilegeCardStyles = "platinum" | "gold" | "sapphire" | "black";

const bhpRwaPersonalDetailsUrl = `https://market.vypzee.com/landing-page?type=Table&id=296&singleCellEdit=true`;
const bhpRwaBusinessDetailsUrl = `https://market.vypzee.com/landing-page?type=Table&id=297&singleCellEdit=true`;

const getOrderLabel = (inp: OrderStatusType, consoleMode: boolean = false) => {
  if (inp === "CREATED") return !consoleMode ? "Created" : "";
  if (inp === "PARTIALLY_ACCEPTED")
    return !consoleMode ? "Acknowledged" : "Request Payment";
  if (inp === "ACCEPTED") return !consoleMode ? "Accepted" : "Process Order";
  if (inp === "PAID") return !consoleMode ? "Paid" : "";
  if (inp === "COMPLETE") return !consoleMode ? "Completed" : "Complete Order";
  if (inp === "CANCELLED") return !consoleMode ? "Cancelled" : "No Show";
  if (inp === "PROCESSING")
    return !consoleMode ? "Processing" : "Set Completion Time";
  if (inp === "READY") return !consoleMode ? "Ready" : "Order Ready";
  if (inp === "PICKED_UP")
    return !consoleMode ? "Picked Up" : "Order Picked Up";
  if (inp === "DECLINED") return !consoleMode ? "Declined" : "Decline";
};

const getOrderLabelColor = (
  inp: OrderStatusType
):
  | "tertiary"
  | "orange"
  | "brown"
  | "purple"
  | "secondary"
  | "success"
  | "medium"
  | "dark"
  | "navblue"
  | "danger"
  | "primary" => {
  if (inp === "CREATED") return "medium";
  if (inp === "PARTIALLY_ACCEPTED") return "dark";
  if (inp === "ACCEPTED") return "secondary";
  if (inp === "PAID") return "navblue";
  if (inp === "COMPLETE") return "success";
  if (inp === "CANCELLED") return "danger";
  if (inp === "PROCESSING") return "purple";
  if (inp === "READY") return "tertiary";
  if (inp === "PICKED_UP") return "brown";
  if (inp === "DECLINED") return "danger";
  return "primary";
};

const getOrderLabelColorWithCssVar = (status: OrderStatusType) => {
  return `var(--ion-color-${getOrderLabelColor(status)}`;
};

export type {
  AdvanceCustomizationType,
  PositionType,
  PrivilegeCardStyles,
  MapsGooglePromptType,
  IprofileExpandingImageModalData,
  QuantifyTraitType,
  PtmStudentData,
  PtmStudentPerLogData,
  HomeWorkDataType,
  ProfileDataType,
  AccoladeDataType,
  AlertWithExecTypes,
  ProfileAccoladeFilterType,
  AlertWithoutExecTypes,
  TeacherInfo,
  ProfileData,
  ExamType,
  ExamEntry,
  SubjectExamEntry,
  StudentExamEntry,
  ClassSectionSessionExamEntry,
  SubjectTeacherInfo,
  SubjectClassSectionSel,
  subjectExamMarks,
  StudentSpecificSubjectExamEntry,
  IntelligenceDataType,
  ClassSectionSessionSpecificSubjectExamEntry,
  ClassSectionSessionBehaviorTraits,
  BehaviorExamEntry,
  BehaviorTraitsMarks,
  StudentMarks,
  ClassSectionSessionStudentBehaviorTraits,
  ExamsBehaviorEntry,
  BehaviorTraitsAllStudentMarks,
  BehaviorTraitsStudentMarks,
  StudentReportObject,
  StudentList,
  ReportCardReviewStruct,
  SubjectIntelligenceTraits,
  StudentAttendanceList,
  MarksBundle,
  ReportCardCommentCategory,
  SaveReportCardCommentObject,
  StudentReportCardComments,
  PerStudentReportCardCommentBundle,
  AnecdoteInputCategory,
  DelReportCardCommentObject,
  StudentAnecdotes,
  PerStudentAnecdoteBundle,
  AnecdoteStudentBundle,
  StudentSubjectAnecdote,
  FileBundleType,
  FunctionalIcons,
  CardGroup,
  LoginInfo,
  ReportCardStudentInfo,
  ReportCardStruct,
  IprofileAcademicScorePerClass,
  IprofileAcademicScorePerSubject,
  AddAccoladeType,
  SubscriptionType,
  AdvertisingDetailsType,
  BussinessCatalogueProducts,
  DashboardNavbarGroupType,
  CartItemTypes,
  OrderStatusType,
  BhpCampaignType,
};

export {
  getGrade,
  getMarksFromGrade,
  AccoladeType,
  iProfileViews,
  // suhaniAccolades,
  reportCardModalStatus,
  // SKILL_PERCENTAGE_LIMIT,
  accoladeWeight,
  ACADEMIC_MARKS_FILTER_LIM,
  bhpRwaBusinessDetailsUrl,
  bhpRwaPersonalDetailsUrl,
  getOrderLabel,
  getOrderLabelColor,
  getOrderLabelColorWithCssVar,
  // activityType,
};
